import "./App.css";
import Index from "./Componet/Home/Index";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import useWordScrollAnimation from "./useWordScrollAnimation";
import AboutUs from "./Componet/About/AboutUs";
import FloatingSocial from "./Componet/Comman/FloatingSocial";
import TalkToPopup from "./Componet/Comman/TalkToPopup";
import CryptocurrencyExchange from "./Componet/Exchange/Cryptocurrency Exchange/CryptocurrencyExchange";
import WhiteLabelExchange from "./Componet/Exchange/White Label Exchange/WhiteLabelExchange";
import MarginTradingE from "./Componet/Exchange/Margin-Trading-Exchange/MarginTradingE";
import SecurityExchange from "./Componet/Exchange/Security Exchange/SecurityExchange";
import PtoPExchange from "./Componet/Exchange/PToP Exchange/PtoPExchange";
import DerivativesExchange from "./Componet/Exchange/Derivatives Exchange/DerivativesExchange";
import ArbitrageTradingBots from "./Componet/Exchange/Arbitrage Trading Bots/ArbitrageTradingBots";
import MarketMakingServices from "./Componet/Exchange/Market Making Services/MarketMakingServices";
import DecentralizedExchange from "./Componet/Exchange/DecentralizedExchange/DecentralizedExchange";
import CryptocurrencyWallet from "./Componet/Wallet/Cryptocurrency Wallet/CryptocurrencyWallet";
import Web3Wallet from "./Componet/Wallet/Web3 Wallet/Web3Wallet";
import CryptoWalletClone from "./Componet/Wallet/Crypto Wallet Clone/CryptoWalletClone";
import BlockchainDevelopment from "./Componet/Blockchain/Blockchain Development/BlockchainDevelopment";
import HashgraphDevelopment from "./Componet/Blockchain/Hashgraph Development/HashgraphDevelopment";
import NFTWallet from "./Componet/Wallet/NFT Wallet/NFTWallet";
import EthereumWallet from "./Componet/Wallet/Ethereum Wallet/EthereumWallet";
import BitcoinWallet from "./Componet/Wallet/Bitcoin Wallet/BitcoinWallet";
import MobileWalletApp from "./Componet/Wallet/Mobile WalletApp/MobileWalletApp";
import DefiWallet from "./Componet/Wallet/DefiWallet/DefiWallet";
import WhiteLabelWallet from "./Componet/Wallet/White Label Wallet/WhiteLabelWallet";
import NFTDevelopment from "./Componet/NFT/NFT Development/NFTDevelopment";
import NFTCollectionLaunch from "./Componet/NFT/NFT Collection Launch/NFTCollectionLaunch";
import NFTMarketplace from "./Componet/NFT/NFT Marketplace/NFTMarketplace";
import NFTLoan from "./Componet/NFT/NFT Loan/NFTLoan";
import NFTGaming from "./Componet/NFT/NFT Gaming/NFTGaming";
import BlockchainGameDev from "./Componet/Blockchain/BlockchainGameDev/BlockchainGameDev";
import Substrate from "./Componet/Blockchain/Blockchain Framework/Substrate/Substrate";
import Tezos from "./Componet/Blockchain/Blockchain Framework/Tezos/Tezos";
import Cosmos from "./Componet/Blockchain/Blockchain Framework/Cosmos/Cosmos";
import PolygonEdge from "./Componet/Blockchain/Blockchain Framework/Polygon Edge/PolygonEdge";
import PolygonBlockchain from "./Componet/Blockchain/Blockchain Framework/Polygon Blockchain/PolygonBlockchain";
import BSC from "./Componet/Blockchain/Layer One and Two Solution/BSC/BSC";
import Ethereum from "./Componet/Blockchain/Layer One and Two Solution/Ethereum/Ethereum";
import Solana from "./Componet/Blockchain/Layer One and Two Solution/Solana/Solana";
import Cardano from "./Componet/Blockchain/Layer One and Two Solution/Cardano/Cardano";
import Polkadot from "./Componet/Blockchain/Layer One and Two Solution/Polkadot/Polkadot";
import TON from "./Componet/Blockchain/Layer One and Two Solution/TON/TON";
import SmartContractDev from "./Componet/Blockchain/Smart Contract/Smart Contract Dev/SmartContractDev";
import DeFiSmartContract from "./Componet/Blockchain/Smart Contract/DeFi Smart Contract/DeFiSmartContract";
import SmartContractAudit from "./Componet/Blockchain/Smart Contract/Smart Contract Audit/SmartContractAudit";
import AssentTekenization from "./Componet/Blockchain/Assent Tekenization/Assent Tekenization/AssentTekenization";
import CryptoAssetManagement from "./Componet/Blockchain/Assent Tekenization/Crypto Asset Management/CryptoAssetManagement";
import EnterpriseSolution from "./Componet/Blockchain/Enterprise Solution/EnterpriseSolution";
import Securitization from "./Componet/Blockchain/Securitization/Securitization";
import P2PLending from "./Componet/Blockchain/P2P Lending/P2PLending";
import ExchangeListing from "./Componet/Listing/Exchange Listing/ExchangeListing";
import TokenListing from "./Componet/Listing/Token Listing/TokenListing";
import CoinGeckoCMCListing from "./Componet/Listing/CoinGecko CMC Listing/CoinGeckoCMCListing";
import CaseStudies from "./Componet/Case Studies/CaseStudies";
import CaseStudyDetails from "./Componet/Case Studies/CaseStudyDetails";
import DeFiStaking from "./Componet/DeFi/DeFiStaking/DeFiStaking";
import DeFiDevelopment from "./Componet/DeFi/DeFiDevelopment/DeFiDevelopment";
import DeFiLottery from "./Componet/DeFi/DeFiLottery/DeFiLottery";
import DeFiLendingAndBorrowing from "./Componet/DeFi/DeFiLendingAndBorrowing/DeFiLendingAndBorrowing";
import DeFiLotteryByXeer from "./Componet/DeFi/DeFiLottery/DeFiLotteryByXeer";
import Marketing from "./Componet/Marketing/Marketing";
import MarketingDetailPage from "./Componet/Marketing/MarketingDetailPage";
import ContactUs from "./Componet/Contact/ContactUs";
import DexAggregator from "./Componet/Exchange/Dex Aggregator/DexAggregator";
import Web3Development from "./Componet/Web3/Web3Dev/Web3Development";
import Web3GameDevelopment from "./Componet/Web3/Web3GameDev/Web3GameDevelopment";
import AMMDexDev from "./Componet/AMM DEX/AMMDexDev";
import AMMDex from "./Componet/AMM DEX/AMMDex";
import OrderBookDEX from "./Componet/Exchange/Order Book DEX/OrderBookDEX";
import CryptoBanking from "./Componet/Exchange/Crypto Banking/CryptoBanking";
import CryptoPaymentGateway from "./Componet/Exchange/Crypto Payment Gateway/CryptoPaymentGateway";
import TokenDevelopment from "./Componet/Exchange/TokenDevelopment/TokenDevelopment";
import IDODevelopment from "./Componet/Exchange/IDO Development/IDODevelopment";
import CryptoLaunchpad from "./Componet/Exchange/Crypto Launchpad/CryptoLaunchpad";
import ICODevelopment from "./Componet/Exchange/ICODevelopment/ICODevelopment";
import CryptoGaming from "./Componet/Exchange/Crypto Gaming/CryptoGaming";
import TradingBot from "./Componet/Exchange/Trading Bot/TradingBot";
import MLM from "./Componet/Exchange/MLM/MLM";
import AIAgent from "./Componet/AI Agent/AIAgent";
import ComingSoon from "./Componet/ComingSoon";
import PrivacyPolicy from "./Componet/PrivacyPolicy/PrivacyPolicy";
import TermsCondition from "./Componet/TermsCondition/TermsCondition";
import Career from "./Componet/Careers/Career";

function App() {
  useWordScrollAnimation();
  return (
    <div>
      <FloatingSocial />
      <TalkToPopup />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about-us" element={<AboutUs />} />
          {/* Exchange Pages */}
          <Route
            path="/cryptocurrency-exchange"
            element={<CryptocurrencyExchange />}
          />
          <Route
            path="/white-label-exchange"
            element={<WhiteLabelExchange />}
          />
          <Route path="/margin-trading-exchange" element={<MarginTradingE />} />
          <Route path="/security-exchange" element={<SecurityExchange />} />
          <Route path="/p2p-exchange" element={<PtoPExchange />} />
          <Route
            path="/decentralized-exchange"
            element={<DecentralizedExchange />}
          />
          <Route
            path="/derivatives-exchange"
            element={<DerivativesExchange />}
          />
          <Route
            path="/arbitrage-trading-bots"
            element={<ArbitrageTradingBots />}
          />
          <Route
            path="/market-making-services"
            element={<MarketMakingServices />}
          />
          {/* Wallet Pages */}
          <Route
            path="/cryptocurrency-wallet"
            element={<CryptocurrencyWallet />}
          />
          <Route path="/web3-wallet" element={<Web3Wallet />} />
          <Route path="/crypto-wallet-clone" element={<CryptoWalletClone />} />
          <Route path="/nft-wallet" element={<NFTWallet />} />
          <Route path="/ethereum-wallet" element={<EthereumWallet />} />
          <Route path="/bitcoin-wallet" element={<BitcoinWallet />} />
          <Route path="/mobile-wallet-app" element={<MobileWalletApp />} />
          <Route path="/defi-wallet" element={<DefiWallet />} />
          <Route path="/white-label-wallet" element={<WhiteLabelWallet />} />
          {/* NFT Development Pages */}
          <Route path="/nft-development" element={<NFTDevelopment />} />
          <Route
            path="/nft-collection-launch"
            element={<NFTCollectionLaunch />}
          />
          <Route path="/nft-marketplace" element={<NFTMarketplace />} />
          <Route path="/nft-loan" element={<NFTLoan />} />
          <Route path="/nft-gaming" element={<NFTGaming />} />
          {/* DeFi Development Pages */}
          <Route path="/defi-development" element={<DeFiDevelopment />} />
          <Route path="/defi-staking" element={<DeFiStaking />} />
          <Route path="/defi-lottery" element={<DeFiLottery />} />
          <Route
            path="/defi-lending-and-borrowing"
            element={<DeFiLendingAndBorrowing />}
          />
          {/* Web3 Development Pages */}
          <Route path="/web-30-devlopment" element={<Web3Development />} />
          <Route
            path="/web3-game-devlopment"
            element={<Web3GameDevelopment />}
          />
          {/* DEX Development Pages */}
          <Route path="/dex-aggregator" element={<DexAggregator />} />
          <Route path="/amm-dex" element={<AMMDex />} />
          <Route path="/order-book-dexs" element={<OrderBookDEX />} />
          {/* Crypto Banking & Payments */}
          <Route path="/crypto-banking" element={<CryptoBanking />} />
          <Route
            path="/cryptocurrency-payment-gateway"
            element={<CryptoPaymentGateway />}
          />
          {/* Token Development */}
          <Route path="/token-development" element={<TokenDevelopment />} />
          <Route path="/ido-development" element={<IDODevelopment />} />
          <Route path="/crypto-launchpad" element={<CryptoLaunchpad />} />
          <Route path="/ico-development" element={<ICODevelopment />} />
          {/* Trading Bots */}
          <Route path="/trading-bot" element={<TradingBot />} />
          {/* Blockchain Development */}
          <Route
            path="/blockchain-development"
            element={<BlockchainDevelopment />}
          />
          <Route
            path="/hashgraph-development"
            element={<HashgraphDevelopment />}
          />
          <Route
            path="/blockchain-game-development"
            element={<BlockchainGameDev />}
          />
          {/* Blockchain Framework */}
          <Route path="/substrate" element={<Substrate />} />
          <Route path="/tezos" element={<Tezos />} />
          <Route path="/cosmos" element={<Cosmos />} />
          <Route path="/polygon-edge" element={<PolygonEdge />} />
          <Route path="/polygon-blockchain" element={<PolygonBlockchain />} />
          <Route path="/bsc" element={<BSC />} />
          <Route path="/ethereum" element={<Ethereum />} />
          <Route path="/solana" element={<Solana />} />
          <Route path="/cardano" element={<Cardano />} />
          <Route path="/polkadot" element={<Polkadot />} />
          <Route path="/ton" element={<TON />} />
          {/* Smart Contract  */}
          <Route
            path="/smart-contract-development"
            element={<SmartContractDev />}
          />
          <Route path="/defi-smart-contract" element={<DeFiSmartContract />} />
          <Route
            path="/smart-contract-audit"
            element={<SmartContractAudit />}
          />
          {/* Assent Tekenization */}
          <Route path="/assent-tekenization" element={<AssentTekenization />} />
          <Route
            path="/crypto-asset-management"
            element={<CryptoAssetManagement />}
          />
          <Route
            path="/enterprise-solutions"
            element={<EnterpriseSolution />}
          />
          <Route path="/securitization" element={<Securitization />} />
          <Route path="/p2p-lending" element={<P2PLending />} />
          {/* Listing */}
          <Route path="/exchange-listing" element={<ExchangeListing />} />
          <Route path="/token-listing" element={<TokenListing />} />
          <Route
            path="/coingecko-and-cmc-listing"
            element={<CoinGeckoCMCListing />}
          />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:id" element={<CaseStudyDetails />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/marketing/:id" element={<MarketingDetailPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/crypto-gaming" element={<CryptoGaming />} />
          <Route path="/mlm" element={<MLM />} />
          <Route path="/ai-agent" element={<AIAgent />} />
          {/* <Route path="/ai-agent" element={<ComingSoon />} /> */}
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsCondition />} />
          <Route path="/career" element={<Career />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
